import { Day } from '@/domain/termine/type';
import { cn } from '@/lib/utils';
import dayjs from 'dayjs';

function formatTodayLocale(day: dayjs.Dayjs) {
  return `${day.locale('de').format('dddd')}, ${day
    .locale('de')
    .format('D. MMMM')}`;
}

export function renderDayHeader(
  day: Day,
  isToday: boolean,
  showHeader: boolean,
) {
  if (!showHeader) return null;
  return (
    <div
      className={cn(
        'pt-4 pb-2 font-semibold',
        isToday && 'text-primary-blue-600',
      )}>
      {formatTodayLocale(day)}
    </div>
  );
}
